import { Link, NavLink } from "react-router-dom";
import HeadingOne from "../layout/headings/HeadingOne";

export default function DashboardMenu() {
  return <div className="dashboard__menu"></div>;
}
